import { render, staticRenderFns } from "./MemberFilterLink.vue?vue&type=template&id=1c896713&scoped=true&"
import script from "./MemberFilterLink.vue?vue&type=script&lang=js&"
export * from "./MemberFilterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c896713",
  null
  
)

export default component.exports